import { SET_STATE, RESET, REQUEST_JOIN_GYM, END_POINT, KICK_PARTICIPANT, ADD_GYM_MEMBER, REMOVE_GYM_MEMBER, LEAVE_GYM, SET_GYM_MEMBERS, SET_GYM_NAME, SET_MY_GYMS, SET_MEMBER_OF_GYMS , SET_OTHER_GYMS, ADD_MY_GYM, SET_SELECTABLE_MEMBERS,SET_GYM_OCCUPATION } from './actionTypes'
import { setDockToSide, toggleMoreActions, sendEndPointMessage, showGymRoom, showAlreadyInGym, hangup } from '../../redux/otuVision/actions'


export function setState ( newState ) {
  return { type : SET_STATE, newState }
}

export function reset () {
  return { type : RESET }
}

export function showGymPortal() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          visible : true,
          showGymPortal: true,
          showManageGym:false,
          showCreateGym:false

        } 
      } 
    )

    // TODO: Extarct to own action and move intiator to user effect of portal
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.getMyGyms', {},{
      responseType : 'json',
      callback : function ( gyms ) {
        dispatch( { 
            type : SET_MY_GYMS,
            gyms
          } 
        )
      } 
    })

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.getMemberOfGyms', {},{
      responseType : 'json',
      callback : function ( gyms ) {
        dispatch( { 
            type : SET_MEMBER_OF_GYMS,
            gyms
          } 
        )
      } 
    })

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.getOtherGyms', {},{
      responseType : 'json',
      callback : function ( gyms ) {
        dispatch( { 
            type : SET_OTHER_GYMS,
            gyms
          } 
        )
      } 
    })

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.getGymOccupation', {},{
      responseType : 'json',
      callback : function ( gyms ) {
        dispatch( { 
            type : SET_GYM_OCCUPATION,
            gyms
          } 
        )
      } 
    })
  
  }

}

export function showCreateGym( gymId = null) {
  
  return (dispatch, getState) => {
  
    const state = getState()

    if ( state.otuVision.visible ) {
      dispatch( showAlreadyInGym );
      return;
    } 

    dispatch( { 
        type : SET_STATE, 
        newState : { 
          visible : true,
          showGymPortal : false,
          showCreateGym : true,
        } 
      } 
    )

  }

}

export function createGym( gym ) {
  
  return (dispatch, getState) => {
  
    const state = getState()

    if ( state.otuVision.visible ) {
      dispatch( showAlreadyInGym );
      return;
    } 

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.createGym', {
      gym 
    },{
      responseType : 'json',
      callback : function ( gym ) {
        
        dispatch( {
          type : ADD_MY_GYM,
          gym
        })


        dispatch( { 
          type : SET_STATE, 
          newState : { 
            showGymPortal : true,
            showCreateGym : false,
          } 
        })


        //dispatch( showGymRoom( { gym } ) )
        dispatch( showGymPortal() )

      }
    } )
  }

}

export function deleteGym( options = {} ) {
  
  return (dispatch, getState) => {
  
    if ( !options.gym ) throw "no gym given"

    const gym = options.gym
    const gymId = gym.gymId 
    const otuVision = options.otuVision

    if ( otuVision ) {
      dispatch( hangup() )
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.deleteGym', {
      gymId
    },
    { responseType : 'json',
      callback : ( confirmation ) => {
        dispatch( showGymPortal() )
      }
    } )
  
  }

}

export function getMemberOfGyms( options = {} ) {
  return (dispatch, getState) => {

    if ( !options.gym ) throw "no gym given"

    const gym = options.gym
    const gymId = gym.gymId ;

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.getMembers', {
      gymId
    },
    { responseType : 'json',
      callback : ( members ) => {
        dispatch( setGymMembers( { 
            gym,
            members
          } 
        ) )
      }
    } )
  }
}

export function getSelectableMembers ( options = {} ) {

  return (dispatch, getState) => {

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.getSelectableMembers', {},{
      responseType : 'json',
      callback : function ( selectableMembers ) {
        dispatch( { 
          type : SET_SELECTABLE_MEMBERS, 
          selectableMembers
        } )
      }
    } )
    
  }

}

export function showManageGym( options = {} ) {
  
  return (dispatch, getState) => {

        dispatch( toggleMoreActions( false ) )

        dispatch( { 
            type : SET_STATE, 
            newState : { 
              visible : true,
              showGymPortal : false,
              showCreateGym : false,
              showManageGym : true,
            } 
          } 
        )
  }

}

export function setGymMembers ( options = {} ) {
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_GYM_MEMBERS, 
        gym: options.gym,
        members : options.members
      } )
  }
}

export function setGymRoom( gym ) {
  throw 'deprecated'
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          gymId : gym.gymId,
          name: gym.gymData.name,
          owner : ( gym.userId || gym.user_id ),
          canManage : ( ( gym.userId || gym.user_id ) == otuApp.appUser.id ),
          members : {},
          selectableMembers: {} 
        } 
      } 
    )
  
  }

}

export function closeGym() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          visible : false,
          showGymPortal: false,
          showCreateGym: false,
          showManageGym: false
        } 
      } 
    )

    otuApp.pageNavigation.restoreTask();
  
  }

}

export function closeCreateGym() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          showCreateGym: false,
          showGymPortal: true

        } 
      } 
    )
  
  }

}

export function closeManageGym() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          showManageGym: false,
          showGymPortal: true

        } 
      } 
    )
  
  }

}

export function sendJoinGymInvitation( gym ) {

  return (dispatch, getState) => {
  
    const state = getState()


    dispatch( sendEndPointMessage( 
        { 
          target : END_POINT,
          action : REQUEST_JOIN_GYM,
          gym

         }, 
        Object.values( state.otuVision.participants) 
      ) 
    )


  }

}

export function sendKickParticipant( [ participantId ] ) {

  return (dispatch, getState) => {

    dispatch( sendEndPointMessage( 
        { 
          target : END_POINT,
          action : KICK_PARTICIPANT
         }, 
        [ participantMissionId ]
      ) 
    )


  }

}

export function receiveEndPointMessage( message ) {

  return ( dispatch, getState ) => {
    console.log( message )

    switch ( message.payload.action ) {
      case REQUEST_JOIN_GYM:
          break;
      case KICK_PARTICIPANT:
        console.log('Gym - Kicking you')
        meetApi.executeCommand('hangup')
        break;
    }

  }
}

export function setGymName ( options ) {
  
  return ( dispatch, getState ) => {

    const state = getState()

    dispatch( { 
        type : SET_GYM_NAME, 
        gym : options.gym,
        name : options.name

      } 
    )

    dispatch( saveGym( state.gym.gyms[ options.gym.gymId ] ) )
  
  }

}

export function saveGym ( gym ) {

  return ( dispatch, getState ) => {

    const data = {
      gym
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.saveGym',data,{
      responseType : 'json',
      noSysInteraction : true, 
      callback : function ( gym ) {

      }
      } )

    }

}

export function addMember ( options = {} ) {

  return ( dispatch, getState ) => {

    const gym=options.gym
    const member = options.member
    
    const data = {
      gymId : gym.gymId,
      memberId : member.id
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.addMember',data,{
      responseType : 'json',
      noSysInteraction :false, 
      callback : function ( newMember ) {

        dispatch( { 
          type : ADD_GYM_MEMBER, 
          member,
          gym

        } )
      }
    } )

  }

}


export function removeMember ( options = {} ) {

  return ( dispatch, getState ) => {

    const gym = options.gym
    const member = options.member

    const data = {
      gymId : gym.gymId,
      memberId : member.id
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.removeMember',data,{
      responseType : 'json',
      noSysInteraction : false, 
      callback : function ( deletedMember ) {
        dispatch( { 
          type : REMOVE_GYM_MEMBER, 
          gym,
          member
        } )
      }
    } )

  }

}

export function leaveGym ( options = {} ) {

  return ( dispatch, getState ) => {

    const gym = options.gym
    const member = options.member
    const otuVision = options.otuVision


    const data = {
      gymId : gym.gymId
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.leaveGym',data,{
      responseType : 'json',
      noSysInteraction : false, 
      callback : function ( deletedMember ) {
        dispatch( { 
          type : LEAVE_GYM, 
          gym,
          member
        } )
        if (otuVision) dispatch(hangup())
      }
    } )

  }

}

export function requestMembership ( options = {} ) {

  return ( dispatch, getState ) => {

    const state= getState()

    const data = {
      gymId : options.gym.gymId,
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=gym.requestMembership',data,{
      responseType : 'json',
      noSysInteraction : true, 
      callback : function ( confirmation ) {
        console.log( confirmation )
      }
    } )

  }

}





